"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["color", "path"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Renders an SVG path within an Icon. Allows styling of individual icon paths.
 */
var IconPath = function IconPath(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '' : _ref$color,
    path = _ref.path,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("path", _extends({
    d: path,
    fill: color
  }, otherProps));
};
IconPath.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Defines a path to be drawn
   */
  path: _propTypes["default"].string,
  /**
   * Optional prop to define the color of the path.
   */
  color: _propTypes["default"].string,
  /**
   * Optional Prop to apply CSS styles to path.
   * It is recommended to use the "fill" property to define the color of a path
   */
  style: _propTypes["default"].object
} : {};
IconPath.displayName = 'IconPath';
var _default = exports["default"] = IconPath;